const DEFAULT_CURRENCY_ABREVIATURE = "EUR" // Define tu abreviatura de moneda predeterminada

export const formatCurrency = (
  number: $TSMigrationFixMe,
  round = false,
  currencyAbreviature = DEFAULT_CURRENCY_ABREVIATURE
) => {
  if (typeof number !== "number") {
    return number
  }

  if (number === null) {
    return "No hay importe"
  }

  const formatter = new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: currencyAbreviature ?? DEFAULT_CURRENCY_ABREVIATURE,
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  const numberToFormat = round ? Math.round(number) : number

  return formatter.format(numberToFormat)
}

export const formatCurrencyWithDecimal = (
  number: $TSMigrationFixMe,
  round = false,
  currencyAbreviature = DEFAULT_CURRENCY_ABREVIATURE
) => {
  if (typeof number !== "number") {
    return number
  }

  if (number === null) {
    return "No hay importe"
  }

  const formatter = new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: currencyAbreviature,
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  const numberToFormat = round ? Math.round(number) : number

  return formatter.format(numberToFormat)
}

export const formatNumber = (number: $TSMigrationFixMe) => {
  const formatter = new Intl.NumberFormat("es-ES", {
    style: "decimal",
    minimumFractionDigits: 2,
    useGrouping: true,
    maximumFractionDigits: 2,
  })
  return formatter.format(number)
}

export const formatTitle = (input: $TSMigrationFixMe) => {
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase()
}
